import React from "react";

import styles from "./MapDropdown.module.scss";

interface Adress {
  id: number;
  text: string;
}
interface MapInfo {
  id: number;
  name: string;
  adress: Adress[];
}

interface MapDropdownProps {
  title: string;
  subtitle: string;
  setGeolocation: (v: string) => void;
  info: MapInfo[];
}

const MapDropdown: React.FC<MapDropdownProps> = ({ title, subtitle, setGeolocation, info }) => {
  const [isActive, setIsActive] = React.useState(false);

  return (
    <div className={isActive ? `${styles.dropdown} ${styles.active}` : styles.dropdown}>
      <h2 className={styles.title} onClick={() => setIsActive(!isActive)}>
        {title}
        <svg width="14" height="8" viewBox="0 0 14 8" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.28895 7.60713L0.631958 1.95013L2.04595 0.536133L6.99596 5.48613L11.946 0.536133L13.36 1.95013L7.70295 7.60713C7.51543 7.7946 7.26112 7.89992 6.99596 7.89992C6.73079 7.89992 6.47648 7.7946 6.28895 7.60713Z"
            fill="currentColor"
          />
        </svg>
      </h2>
      <p className={styles.subtitle}>{subtitle}</p>
      <div className={styles.content}>
        {info.map((adress) => (
          <div className={styles.list} key={adress.id}>
            <h3 onClick={() => setGeolocation(adress.name)}>
              <svg fill="#000000" height="20px" width="20px" version="1.1" id="Capa_1" viewBox="0 0 35.219 35.219">
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  {" "}
                  <g>
                    {" "}
                    <path d="M17.612,0C11.005,0,5.648,5.321,5.648,11.885c0,3.358,3.294,9.374,3.294,9.374l8.229,13.96l8.586-13.797 c0,0,3.814-5.74,3.814-9.537C29.572,5.321,24.216,0,17.612,0z M17.556,18.431c-3.784,0-6.849-3.065-6.849-6.853 c0-3.783,3.064-6.846,6.849-6.846c3.782,0,6.85,3.063,6.85,6.846C24.406,15.366,21.338,18.431,17.556,18.431z"></path>{" "}
                    <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g>{" "}
                    <g> </g> <g> </g> <g> </g>{" "}
                  </g>{" "}
                </g>
              </svg>
              {adress.name}
            </h3>
            <ul>
              {adress.adress.map((item) => (
                <li className={styles.item} key={item.id}>
                  {item.text}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MapDropdown;
